export default function getExternalLinkProps() {
  return ({
    target: '_blank',
    rel: 'noreferrer noopener',
  });
}
